import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

class FilterBtn extends React.PureComponent {
  static propTypes = {
    onClick: PropTypes.func,
    toggle: PropTypes.string
  };

  render() {
    return (
      <a className={'filter-btn' + ' ' + this.props.toggle} data-value="filters"
         onClick={(e) => this.props.onClick(e)}>
        <FormattedMessage id="filters">
          {(message) => <span>{message}</span>}
        </FormattedMessage>
      </a>
    );
  }
}


export default FilterBtn;




/** WEBPACK FOOTER **
 ** ./src/components/nav/FilterBtn.js
 **/